import { Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@material-ui/core";
import { AddAlert } from "@material-ui/icons";
import keyBy from "lodash/keyBy";
import React, { useState } from "react";
import {
  BooleanField,
  Button,
  Datagrid,
  ListContextProvider,
  Pagination,
  ReferenceField,
  TextField,
} from "react-admin";
import { Separator } from "../../../Components/Separator";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { ConditionField } from "./ConditionField";
export const ImportExcelInformationDialog = props => {
  const { openPopup, setOpenPopup, setLoading, tempData, notify, refresh, dataProvider } = props;
  const [page, setPage] = useState(1);
  const perPage = 10;
  const handleClose = () => setOpenPopup(false);
  const handleClickSubmit = () => {
    setOpenPopup(false);
    setLoading(true);
    let data = tempData.filter(condition => condition.isSuccess === true);
    if (data.length === 0) {
      setLoading(false);
      return;
    }
    sendExcelImportData(data);
  };

  const sendExcelImportData = (data: any[]) => {
    dataProvider
      .postHomebaseComponentBulkCreate(data)
      .then(response => {
        if (response.data === true) {
          notify("Success", "info");
          refresh();
        } else {
          notify("Unknown Error", "info");
        }
        setLoading(false);
      })
      .catch(error => {
        notify(`Failed: ${error.message}`, "error");
        setLoading(false);
      });
  };

  const GetTempData = () => {
    return tempData?.slice?.((page - 1) * perPage, perPage * page);
  };

  return (
    // <Grid>
    <Dialog open={openPopup} onClose={handleClose} fullWidth={true} maxWidth={"lg"}>
      <DialogTitle id="alert-dialog-title">{"Excel Import Report"}</DialogTitle>
      <Divider />
      <Separator />
      <Chip
        key={999999}
        color="primary"
        variant="outlined"
        label="Unsuccessfull records will not be inserted!"
        style={{ margin: "auto" }}
        icon={<AddAlert />}
      />
      <DialogContent>
        <ListContextProvider
          value={{
            data: keyBy(GetTempData() ?? [], "id"),
            ids: GetTempData()?.map?.(({ id }) => id),
            currentSort: { field: "id", order: "ASC" },
          }}
        >
          <Datagrid optimized hasBulkActions={false}>
            <TextField source="refNo" />
            <ReferenceField label="Customer" source="customerId" reference={SourceCustomer} link={false}>
              <TextField source="customerName" />
            </ReferenceField>
            <ReferenceField label="Warehouse" source="warehouseId" reference={"homebasewarehouses"} link={false}>
              <TextField source="location" />
            </ReferenceField>
            <TextField source="pn" />
            <TextField source="sn" />
            <TextField source="condition" />
            <BooleanField label="Success" source="isSuccess" />
            <ConditionField source="description" />
          </Datagrid>
          <Pagination
            //@ts-ignore
            page={page}
            perPage={perPage}
            setPage={setPage}
            total={tempData.length}
          />
        </ListContextProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} label="Cancel" />
        <Button onClick={handleClickSubmit} label="Save" />
      </DialogActions>
    </Dialog>
    // </Grid>
  );
};
